/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Label } from '@americanexpress/dls-react';
import AdvFormSearchItem from './AdvFormSearchItem';
import AdvFormSelectItem from './AdvFormSelectItem';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';
import AdvFormDateSelectItem from './AdvFormDateSelectItem';
import AdvFormTimeSelectItem from './AdvFormTimeSelectItem';
import AdvFormDateRangeSelectItem from './AdvFormDateRangeSelectItem';
import AdvFormInputItem from './AdvFormInputItem';
import AdvFormTimeZoneSelectItem from './AdvFormTimeZoneSelectItem';
import AdvFormSearchSelectItem from './AdvFormSearchSelectItem';
import AdvFormDateTimeRangeSelectItem from './AdvFormDateTimeSelectItem';
import AdvFormMutilSelectItem from './AdvFormMutilSelectItem';
import AdvFormSearchItemV2 from './AdvFormSearchItemV2';
import AdvFormCheckboxItem from './AdvFormCheckboxItem';
import AdvFormMutilSelectItemV2 from './AdvFormMutilSelectItemV2';

const renderLabel = (labelNm, fieldNm, type) => {
  if (type === 'date-range' || type === 'checkbox') {
    return null;
  }
  return (
    <Label id={`advFormSearch-lbl-${fieldNm}`} htmlFor={`${fieldNm}`}>
      {labelNm}
    </Label>
  );
};

// eslint-disable-next-line max-params,complexity
export const renderAdvFormFieldComponent = (data, pageData, setPageData, acsMgmt, loginData) => {
  switch (data.type) {
    case 'search':
      return (
        <AdvFormSearchItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
          acsMgmt={acsMgmt}
          loginData={loginData}
        />
      );
    case 'AdvFormSearchItemV2':
      return (
        <AdvFormSearchItemV2
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
          acsMgmt={acsMgmt}
          loginData={loginData}
        />
      );
    case 'date':
      return (
        <AdvFormDateSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    case 'time':
      return (
        <AdvFormTimeSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    case 'time-zone':
      return (
        <AdvFormTimeZoneSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
          loginData={loginData}
        />
      );
    case 'date-range':
      return (
        <AdvFormDateRangeSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    case 'date-time-range':
      return (
        <AdvFormDateTimeRangeSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    case 'input':
      return (
        <AdvFormInputItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    case 'search-select':
      return (
        <AdvFormSearchSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
          acsMgmt={acsMgmt}
          loginData={loginData}
        />
      );
    case 'multi-select':
      return (
        <AdvFormMutilSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );

    case 'multi-selectV2':
      return (
        <AdvFormMutilSelectItemV2
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
          acsMgmt={acsMgmt}
          loginData={loginData}
        />
      );

    case 'checkbox':
      return (
        <AdvFormCheckboxItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
    default:
      return (
        <AdvFormSelectItem
          key={data.id}
          formField={data}
          pageData={pageData}
          setPageData={setPageData}
        />
      );
  }
};
// eslint-disable-next-line max-params
const getRenderedRows = (list, pageData, setPageData, acsMgmt, loginData) => {
  let i = 0;
  let rows = [];
  const finalRenderedRows = [];
  list.forEach((data) => {
    const classNameLocal = data.type === 'date-range' ? 'col-md-6' : 'col-md-3';
    const component = data.type === 'date-time-range'
      ? renderAdvFormFieldComponent(data, pageData, setPageData, acsMgmt, loginData)
      : (
        <div key={data.id} id={data.id} className={classNameLocal}>
          {renderLabel(data.label, data.name, data.type)}
          {renderAdvFormFieldComponent(data, pageData, setPageData, acsMgmt, loginData)}
        </div>
      );
    if (data?.addInNewRow) {
      // Push the current row if it has items
      if (rows.length > 0) {
        finalRenderedRows.push(
          <div css={advFormStyles['.formRow']} className="row">{rows}</div>
        );
        rows = []; i = 0;
      }
      // Add the new row with the single element
      finalRenderedRows.push(
        <div css={advFormStyles['.formRow']} className="row">{component}</div>
      );
    } else if (data?.rangeComponent) {
      rows.push(component);
      i += 2;
      // If the row has 4 elements add it to finalRenderedRows and reset
      if (i % 4 === 0) {
        finalRenderedRows.push(
          <div css={advFormStyles['.formRow']} className="row">{rows}</div>
        );
        rows = []; i = 0;
      }
    } else {
      rows.push(component);
      i += 1;
      // If the row has 4 elements add it to finalRenderedRows and reset
      if (i % 4 === 0) {
        finalRenderedRows.push(
          <div css={advFormStyles['.formRow']} className="row">{rows}</div>
        );
        rows = []; i = 0;
      }
    }
  });
  // Push remaining rows if any
  if (rows.length !== 0) {
    finalRenderedRows.push(
      <div css={advFormStyles['.formRow']} className="row">{rows}</div>
    );
  }
  return finalRenderedRows;
};

// eslint-disable-next-line max-params
export const getFormFields = (pageData, setPageData, acsMgmt, loginData, appFormFields) => {
  if (appFormFields) {
    const appDetailList = pageData.formFields.filter((data) => Object.prototype.hasOwnProperty.call(data, 'additionalDetail') && data.additionalDetail);
    return getRenderedRows(appDetailList, pageData, setPageData, acsMgmt, loginData);
  }
  const formFieldList = pageData.formFields.filter((data) => !Object.prototype.hasOwnProperty.call(data, 'additionalDetail') && !data.additionalDetail);
  return getRenderedRows(formFieldList, pageData, setPageData, acsMgmt, loginData);
};
